<template>
  <div style="margin-bottom: 10px">
    <b-form @submit.prevent>
      <b-row>
        <b-col cols="12">
          <b-input-group class="input-group-merge">
            <b-input-group-prepend is-text>
              <feather-icon icon="SearchIcon" />
            </b-input-group-prepend>
            <b-form-input
              id="vi-id"
              v-model="keyword"
              :placeholder="placeholderLabel"
              v-on:keyup.enter="goToObject"
            />
          </b-input-group>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import {
  BRow, BCol, BForm, BFormInput, BInputGroupPrepend, BInputGroup,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'DataTable',
  components: {
    BFormInput,
    BForm,
    BCol,
    BRow,
    BInputGroupPrepend,
    BInputGroup,
  },
  directives: {
    Ripple,
  },
  props: {
    route: {
      type: String,
      default: '/',
    },
    placeholder: {
      type: String,
      default: '/',
    },
  },
  data() {
    return {
      keyword: '',
      book: {},
      placeholderLabel: this.placeholder,
    }
  },
  mounted() {
  },
  methods: {
    goToObject() {
      this.$router.push(`${this.route}/${this.keyword}`)
    },
  },
}
</script>
